import React from 'react'
import { Round } from '@/redux/reducers/gameReducer'
import YeekeeResultV2 from '@/ui-components/components/BetLotto/YeekeeResult/YeekeeResultV2'
import ShootNumber from '@/ui-components/components/BetLotto/ShootNumber/ShootNumber'
import useShootNumber from '../hooks/useShootNumber'
import useYeekeeResult from '../hooks/useYeekeeResult'

interface ShootTabProps {
  round?: Round
  isResulted: boolean
}

export const ShootTab: React.FC<ShootTabProps> = ({ round, isResulted }) => {
  const shootNumberProps = useShootNumber(round, isResulted)
  const { getYeekeeResultProps } = useYeekeeResult()

  if (isResulted && round) {
    const yeekeeProps = getYeekeeResultProps(round)

    return (
      <YeekeeResultV2
        {...yeekeeProps}
        memberPutNumbers={{
          entries: shootNumberProps.currentPutNumbers,
          currentPage: shootNumberProps.currentPage,
          totalPages: shootNumberProps.totalPages,
          onPageChange: shootNumberProps.handlePageChange,
          isLoading: shootNumberProps.isLoading,
        }}
      />
    )
  }

  return <ShootNumber {...shootNumberProps} />
}

export default ShootTab
